module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp13_7016.719cb1dc.png";